import Vue from 'vue'

Vue.mixin({
    data() {
        return {
            pageAdmin: false
        };
    },
    async mounted() {
        this.pageAdmin = await this.isAdmin("stipendMage");
    }
})